import { OrderCategory } from "../../../api/endpoints/Order";
import { groupBy, map } from "lodash";
import { formatRun } from "../../../utils/Format";
import React, { ElementType, Fragment } from "react";
import { TOrderProductData } from "../../../api/endpoints/OrderProduct";
import { StepRange } from "../../../entities/StepRange";

const formatSteps = (steps: Array<string>) => {
  return steps.join('/');
}

const Run = (props: {
  values: TOrderProductData<OrderCategory.REALTIME>['use_step']
  as: ElementType
}) => {
  const { values, as: Component } = props;

  const grouped = groupBy(values, (value ) => value.use);

  return (
    <Fragment>
      {
        map(grouped, (values, use) => {
          return (
            <Component key={use}>
              {formatRun(Number(use))}:
              &nbsp;
              {formatSteps(values.map(value => value.step))}
            </Component>
          );
        })
      }
    </Fragment>
  );
};

export default Run;
